module.exports = __webpack_public_path__ + "img/ic_feedback_message.6c607678.svg";